import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class BarcodeGenerationSvc {

  // Observable string sources
  public generateBarcodeSource = new Subject<string>();
  constructor(private httpClient: HttpClient) {
  }
  // Service message commands
  public generateBarcode(productId: string) {
    this.generateBarcodeSource.next(productId);
  }
  public downloadBarCode(gtin : string, typeImage: string , size: number) : Observable<Blob | string> {
    const query = `text=${gtin}&typeImage=${typeImage}&size=${size}`;
    const URL = `${environment.API_URL}/barcode?${query}`;
    if (typeImage === 'svg') {
    return this.httpClient.get(URL, { responseType: 'text' });
  } else {
    const res = this.httpClient.get(URL, { responseType: 'blob' });
    return res;
  }
  }
}
